module.exports = "/assets/bw-logo.png?ROIweud";